module.exports = __webpack_public_path__ + "img/Header_LandBasedGames.5e275dff.png";